import React from 'react';
import { cn } from '@/lib/utils';

export const SectionHeader = ({ eyebrow, title, description, align = 'left', className }) => (
  <div className={cn(align === 'center' && 'text-center mx-auto max-w-2xl', 'mb-10', className)} data-testid="section-header">
    {eyebrow && (
      <div className={cn(
        'inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-primary',
      )}>
        {eyebrow}
      </div>
    )}
    <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground text-balance">
      {title}
    </h2>
    {description && (
      <p className="mt-3 text-base text-muted-foreground max-w-3xl">
        {description}
      </p>
    )}
  </div>
);
